import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyHelpdesk({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M109.66 28.62c-33.18 23.76-80.3 24-96.34 61.24C3.36 113 26.07 148.93 69.4 154.89c43.33 5.96 70.86-14.18 109.09-11.38 38.23 2.8 50.62-27.1 49.45-47.15-3.38-57.68-54.55-103.5-118.27-67.74z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.16 104.82c27 15.56 68.85 11.89 113.34-6.84 32.25-13.58 72.2-15.7 102.87-7.85.25 2.06.43 4.14.56 6.23 1.17 20.05-11.22 49.95-49.45 47.15-17.61-1.3-32.95 2.29-48.61 5.94-18.33 4.28-37.1 8.66-60.48 5.44-34.72-4.78-56.2-28.8-58.23-50.07z"
        fill="#8F9DD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165 91v.64c4.06 1.45 7 5.3 7 9.86v7c0 5.79-4.71 10.5-10.5 10.5H158a3.5 3.5 0 01-3.5-3.5v-21A3.5 3.5 0 01158 91c0-19.3-16.7-35-36-35S86 71.7 86 91a3.5 3.5 0 013.5 3.5v21A3.5 3.5 0 0186 119h-3.5c-5.79 0-10.5-4.71-10.5-10.5v-7c0-4.56 2.93-8.4 7-9.86V91c0-23.16 19.84-42 43-42s43 18.84 43 42zm-8 33.25c.04-.55.48-1 1.03-1h4.8c.54 0 1 .45.97 1A23.78 23.78 0 01140.07 147h-16.96a6.8 6.8 0 010-13.57h6.78a6.8 6.8 0 016.79 6.78h3.4a17 17 0 0016.93-15.96z"
        fill="#717074"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.1 119.11a1 1 0 01-.19-1.6 30 30 0 10-21.02 8.49h25.6c2.67 0 3.52-2.65 1.17-3.93-1.17-.64-2.36-1.27-3.44-1.83l-2.12-1.13z"
        fill="#fff"
        filter="url(#pic-empty-helpdesk_svg__a)"
      />
      <path
        d="M119.48 105.6h6.1v5.91h-6.1v-5.92zM112 90.83c.16-3.9 1.52-6.66 4.08-8.28a10.75 10.75 0 015.94-1.56c3.09 0 5.65.74 7.69 2.21 2.04 1.48 3.07 3.66 3.07 6.56a7.4 7.4 0 01-1.33 4.49 15.3 15.3 0 01-3 2.83L127 98.2a4.41 4.41 0 00-1.58 2.16 9.04 9.04 0 00-.26 2.41h-5.54c.08-2.3.3-3.9.66-4.77.35-.89 1.27-1.9 2.75-3.05l1.5-1.17c.48-.37.88-.77 1.18-1.21a4.1 4.1 0 00.82-2.48 4.7 4.7 0 00-.92-2.83c-.6-.86-1.71-1.29-3.32-1.29-1.59 0-2.71.53-3.38 1.58a6.11 6.11 0 00-.99 3.28H112z"
        fill="#FB8F23"
      />
      <circle cx={67} cy={38} r={24} fill="#6C7EC9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.95 43.1l-4.28-4.28a2.7 2.7 0 00-3.11-.5l-3.9-3.9v-2.26L60 28.66l-2.33 2.33 3.5 4.67h2.27l3.89 3.9a2.72 2.72 0 00.5 3.11l4.28 4.27c.53.54 1.4.54 1.92 0l1.93-1.92c.53-.53.53-1.4 0-1.92zm-6.19-6.23c1.04 0 2 .4 2.74 1.13l.7.7a5.17 5.17 0 002.99-6.06.44.44 0 00-.74-.2l-2.71 2.72-2.48-.42-.41-2.47 2.71-2.72a.44.44 0 00-.2-.74 5.26 5.26 0 00-4.99 1.39 5.17 5.17 0 00-1.5 3.78l3 3c.29-.08.6-.11.9-.11zm-3.79 3l-2.07-2.08-5.56 5.57a2.33 2.33 0 103.3 3.3l4.51-4.51a3.92 3.92 0 01-.18-2.29zm-5.97 6a.87.87 0 11.88-.88c0 .49-.4.88-.88.88z"
        fill="#fff"
      />
      <circle cx={204} cy={69} r={24} fill="#6C7EC9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M196.02 59.22c-1 0-1.8.8-1.8 1.8v13.65c0 1 .8 1.8 1.8 1.8h4.72a9.06 9.06 0 019.3-10.92v-4.53c0-1-.81-1.8-1.8-1.8h-12.22zm2.58 5.32h7.04c.54 0 .98-.39.98-.87 0-.47-.44-.86-.98-.86h-7.04c-.54 0-.97.39-.97.86 0 .48.43.87.97.87zm1.9 3.88h-2.01a.86.86 0 010-1.73h2.01a.86.86 0 010 1.73zm16 6.18a6.9 6.9 0 11-13.8 0 6.9 6.9 0 0113.8 0zm-10.15-1a.93.93 0 011.32 0l1.3 1.3 2.56-2.54a.93.93 0 111.32 1.32l-3.21 3.2a.94.94 0 01-1.32 0l-1.97-1.96a.93.93 0 010-1.32z"
        fill="#fff"
      />
      <defs>
        <filter
          id="pic-empty-helpdesk_svg__a"
          x={88}
          y={64}
          width={68}
          height={68}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3002_495" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3002_495" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyHelpdesk.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyHelpdesk.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyHelpdesk svgRef={ref} {...props} />
));
export default ForwardRef;
